import axios from 'axios';
import AjaxUtil from '../../axios/axios';
import { karnatakaBrainHealth } from './utils';
import { get } from 'lodash';

// const apiUrls = {
//     getGroups : "https://dev.coguide.in/api/v1/user/groups?topic_id=C12039",
//     getForms : "https://dev.coguide.in/api/v1/user/forms/6729b650e26e4745131d8d59",
//     formStats : "https://dev.coguide.in/api/v1/user/formstats/6729b7cae26e4745131d8d5e"
// }

export const getGroups = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`groups?topic_id=${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getForms = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`forms/${id}?analytics=all`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getFormData = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`form/${id}/fullresp`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getFormStats = async(id, data=[]) => {
    try {
        return await AjaxUtil.sendRequest(`formstats/${id}`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getFormStatskabhi = async(id, data=[]) => {
    try {
        return await AjaxUtil.sendRequest(`kabhiformstats/${id}`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const getDashConfig = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`dashconfig/${id}`, {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

export const saveDashConfig = async(id,data) => {
    try {
        return await AjaxUtil.sendRequest(`dashconfig/${id}`, data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}